// src/pages/AddUnit.jsx
import React, { useState, useEffect } from "react";
import axios from '../../axios';
import API_BASE_URL from "../../config";
import { useNavigate } from "react-router-dom";
import { 
  Container, Paper, Typography, Grid, TextField, Button, Table, 
  TableHead, TableRow, TableCell, TableBody, IconButton, 
  CircularProgress, Box, Dialog, DialogContent 
} from "@mui/material";
import { Delete as DeleteIcon, Edit as EditIcon, Scale as ScaleIcon } from "@mui/icons-material";

export default function AddUnit() {
  const navigate = useNavigate();
  const companyId = parseInt(localStorage.getItem("companyId"), 10);

  const [formData, setFormData] = useState({ nameAr: "", nameEn: "" });
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [successModal, setSuccessModal] = useState(false);

  useEffect(() => {
    fetchUnits();
  }, []);

  const fetchUnits = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/Unit/by-company/${companyId}`);
      setUnits(res.data);
    } catch (err) { console.error("❌ خطأ تحميل الوحدات:", err); }
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/Unit`, { ...formData, companyId });
      // إظهار نافذة النجاح العصرية
      setSuccessModal(true);
      setTimeout(() => setSuccessModal(false), 2000);
      setFormData({ nameAr: "", nameEn: "" });
      fetchUnits();
    } catch (err) {
      alert(err.response?.data?.message || "❌ حدث خطأ أثناء الحفظ");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async id => {
    if (!window.confirm("❗ هل تريد تعطيل هذه الوحدة؟")) return;
    try {
      await axios.delete(`${API_BASE_URL}/Unit/${id}`);
      fetchUnits();
    } catch (err) { alert("❌ حدث خطأ أثناء الحذف"); }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 6 }} dir="rtl">
      
{/* Header - ترويسة مختصرة تعتمد على الثيم */}
<Box
  sx={{
    display: 'flex',
    alignItems: 'center',
    gap: 1.2,
    px: { xs: 1, sm: 2 },
    py: 1.5,
    mb: 2,
    borderBottom: 1,
    borderColor: 'divider',
  }}
>
  <ScaleIcon
    sx={{
      fontSize: 26,
      color: 'primary.main',
    }}
  />

  <Typography
    variant="h6"
    sx={{
      fontWeight: 800,
      color: 'text.primary',
      fontSize: { xs: '1rem', sm: '1.2rem' },
    }}
  >
    إدارة وحدات القياس
  </Typography>
</Box>


      {/* نموذج الإضافة */}
      <Paper elevation={0} sx={{ p: 4, mb: 4, borderRadius: '24px', border: '1px solid #e2e8f0' }}>
        <form onSubmit={handleSubmit} className="space-y-6">
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="الاسم العربي" name="nameAr" value={formData.nameAr} onChange={handleChange} required sx={{ '& .MuiOutlinedInput-root': { borderRadius: '16px' } }} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="الاسم الإنجليزي" name="nameEn" value={formData.nameEn} onChange={handleChange} sx={{ '& .MuiOutlinedInput-root': { borderRadius: '16px' } }} />
            </Grid>
          </Grid>
          <Button
  type="submit"
  variant="contained"
  color="primary"
  disabled={loading}
  size="large"
  fullWidth
  sx={{
    borderRadius: 2,
    py: 1.5,
  }}
>
  {loading ? (
    <CircularProgress size={24} color="inherit" />
  ) : (
    '💾 حفظ '
  )}
</Button>
        </form>
      </Paper>

      {/* جدول الوحدات */}
      <Paper elevation={0} sx={{ p: 4, borderRadius: '24px', border: '1px solid #e2e8f0', overflowX: 'auto' }}>
        <Typography variant="h6" sx={{ mb: 3, fontWeight: 800 }}>📋 قائمة الوحدات المضافة</Typography>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: '#f8fafc' }}>
              {["#", "الاسم (عربي)", "الاسم (إنجليزي)", "الكود", "الحالة", "الإجراءات"].map(h => <TableCell key={h} align="center" sx={{ fontWeight: 'bold' }}>{h}</TableCell>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {units.map((u, idx) => (
              <TableRow key={u.id}>
                <TableCell align="center">{idx + 1}</TableCell>
                <TableCell align="center" sx={{ fontWeight: 600 }}>{u.nameAr}</TableCell>
                <TableCell align="center">{u.nameEn || "-"}</TableCell>
                <TableCell align="center">{u.code}</TableCell>
                <TableCell align="center">{u.isActive ? "✅ مفعل" : "❌ معطل"}</TableCell>
                <TableCell align="center">
                  <IconButton color="warning" onClick={() => navigate(`/edit-unit/${u.id}`)}><EditIcon /></IconButton>
                  <IconButton color="error" onClick={() => handleDelete(u.id)}><DeleteIcon /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      {/* نافذة النجاح الموحدة */}
      <Dialog open={successModal} PaperProps={{ sx: { borderRadius: '24px', p: 3, width: '350px', textAlign: 'center' } }}>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <Box sx={{ width: 80, height: 80, borderRadius: '50%', border: '2px solid #22c55e', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
            </Box>
            <Typography variant="h6" fontWeight="bold">تم الحفظ بنجاح</Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </Container>
  );
}